import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      navbar: {
        home: "Home",
        about: "About",
        services: "Services",
        vision: "Our Vision",
        contact: "Contact",
      },
      home: { welcome: "Welcome to", subtitle: "We create new technologies!" },
      about: {
        title: "About Us",
        welcome: "Welcome to Rook Tech!",
        highlight: "Where innovation meets purpose.",
        p1: "We are an application development company dedicated to creating impactful and accessible products tailored to the unique needs of the developing world.",
        p2: "Our mission is to leverage cutting-edge technology to solve real-world problems, enhance connectivity, and improve the quality of life for communities around the globe.",
        p3: "Join us on our journey to make a meaningful difference through thoughtful and inclusive digital solutions.",
      },
      services: {
        title: "Our Work",
        subtitle:
          "Check out some of our latest projects and digital solutions.",

        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg helps you master the most useful words in any language through fun mini games based on frequency lists.",

        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "The LangoDawg Mobile version, just like the web version, helps you master the most useful words in any language through fun mini-games based on frequency lists.",

        viewProject: "View Project",
        visitWebsite: "Visit Website",
        downloadAndroid: "Android App",
        downloadIOS: "iOS App",

        webPlatformTag: "Web Platform",
        mobileAppTag: "Mobile App",
      },
      mission: {
        visionTitle: "Our Vision",
        visionP1:
          "At Rook Tech, our vision is to become a global leader in application development by harnessing the power of technology to create innovative and sustainable solutions for the developing world.",
        visionP2:
          "We envision a future where every community, regardless of geographical and economic barriers, has access to digital tools that enhance quality of life, foster growth, and drive positive change.",
        missionTitle: "Our Mission",
        missionP1:
          "Our mission at Rook Tech is to design and develop high-quality, user-centric applications that address the unique challenges faced by communities in the developing world.",
        missionP2:
          "We are committed to empowering individuals and organizations through technology, promoting digital inclusion, and driving social impact. By focusing on collaboration, innovation, and integrity, we aim to build solutions that not only meet immediate needs but also pave the way for long-term development and prosperity.",
      },
      contact: {
        title: "Contact Us",
        text: "You can email us at contact@rook-tech.com and we will be happy to reply ASAP!",
      },
    },
  },

  pt: {
    translation: {
      navbar: {
        home: "Início",
        about: "Sobre",
        services: "Serviços",
        vision: "Nossa Visão",
        contact: "Contato",
      },
      home: {
        welcome: "Bem-vindo à",
        subtitle: "Nós criamos novas tecnologias!",
      },
      about: {
        title: "Sobre Nós",
        welcome: "Bem-vindo à Rook Tech!",
        highlight: "Onde a inovação encontra o propósito.",
        p1: "Somos uma empresa de desenvolvimento de aplicativos dedicada a criar produtos impactantes e acessíveis, adaptados às necessidades únicas do mundo em desenvolvimento.",
        p2: "Nossa missão é aproveitar a tecnologia de ponta para resolver problemas do mundo real, aumentar a conectividade e melhorar a qualidade de vida das comunidades em todo o mundo.",
        p3: "Junte-se a nós em nossa jornada para fazer uma diferença significativa por meio de soluções digitais pensadas e inclusivas.",
      },
      services: {
        title: "Nossos Projetos",
        subtitle:
          "Confira alguns de nossos projetos recentes e soluções digitais.",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "O LangoDawg ajuda você a dominar as palavras mais úteis em qualquer idioma através de minijogos divertidos baseados em listas de frequência.",
        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "A versão LangoDawg Mobile, assim como a versão web, ajuda você a dominar as palavras mais úteis em qualquer idioma através de minijogos divertidos baseados em listas de frequência.",
        viewProject: "Ver Projeto",
        visitWebsite: "Visitar Site",
        downloadAndroid: "Baixar para Android",
        downloadIOS: "Baixar para iOS",
        webPlatformTag: "Plataforma Web",
        mobileAppTag: "App Mobile",
      },
      mission: {
        visionTitle: "Nossa Visão",
        visionP1:
          "Na Rook Tech, nossa visão é nos tornarmos líderes globais no desenvolvimento de aplicativos, aproveitando o poder da tecnologia para criar soluções inovadoras e sustentáveis para o mundo em desenvolvimento.",
        visionP2:
          "Visualizamos um futuro onde cada comunidade, independentemente de barreiras geográficas e econômicas, tenha acesso a ferramentas digitais que melhorem a qualidade de vida e impulsionem mudanças positivas.",
        missionTitle: "Nossa Missão",
        missionP1:
          "Nossa missão na Rook Tech é projetar e desenvolver aplicativos de alta qualidade e centrados no usuário, que abordem os desafios únicos enfrentados pelas comunidades no mundo em desenvolvimento.",
        missionP2:
          "Estamos comprometidos em capacitar indivíduos e organizações por meio da tecnologia, promovendo a inclusão digital e impulsionando o impacto social. Ao priorizar a colaboração, a inovação e a integridade, buscamos construir soluções que não apenas atendam às necessidades imediatas, mas também abram caminho para o desenvolvimento e a prosperidade a longo prazo.",
      },
      contact: {
        title: "Contate-nos",
        text: "Você pode nos enviar um e-mail para contact@rook-tech.com e teremos o prazer de responder o mais rápido possível!",
      },
    },
  },

  es: {
    translation: {
      navbar: {
        home: "Inicio",
        about: "Sobre Nosotros",
        services: "Servicios",
        vision: "Nuestra Visión",
        contact: "Contacto",
      },
      home: {
        welcome: "Bienvenido a",
        subtitle: "¡Creamos nuevas tecnologías!",
      },
      about: {
        title: "Sobre Nosotros",
        welcome: "¡Bienvenido a Rook Tech!",
        highlight: "Donde la innovación encuentra el propósito.",
        p1: "Somos una empresa de desarrollo de aplicaciones dedicada a crear productos impactantes y accesibles, adaptados a las necesidades únicas del mundo en desarrollo.",
        p2: "Nuestra misión es aprovechar la tecnología de vanguardia para resolver problemas del mundo real, mejorar la conectividad y aumentar la calidad de vida de las comunidades en todo el mundo.",
        p3: "Únase a nosotros en nuestro viaje para marcar una diferencia significativa a través de soluciones digitales pensadas e inclusivas.",
      },
      services: {
        title: "Nuestro Trabajo",
        subtitle:
          "Echa un vistazo a algunos de nuestros últimos proyectos y soluciones digitales.",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg te ayuda a dominar las palabras más útiles en cualquier idioma a través de divertidos minijuegos basados en listas de frecuencia.",
        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "La versión móvil de LangoDawg, al igual que la versión web, te ayuda a dominar las palabras más útiles en cualquier idioma a través de divertidos minijuegos basados en listas de frecuencia.",
        viewProject: "Ver Proyecto",
        visitWebsite: "Visitar Sitio",
        downloadAndroid: "App Android",
        downloadIOS: "App iOS",
        webPlatformTag: "Plataforma Web",
        mobileAppTag: "App Móvil",
      },
      mission: {
        visionTitle: "Nuestra Visión",
        visionP1:
          "En Rook Tech, nuestra visión es convertirnos en un líder mundial en el desarrollo de aplicaciones aprovechando el poder de la tecnología para crear soluciones innovadoras y sostenibles para el mundo en desarrollo.",
        visionP2:
          "Visualizamos un futuro donde cada comunidad, independientemente de las barreras geográficas y económicas, tenga acceso a herramientas digitales que mejoren la calidad de vida, fomenten el crecimiento e impulsen un cambio positivo.",
        missionTitle: "Nuestra Misión",
        missionP1:
          "Nuestra misión en Rook Tech es diseñar y desarrollar aplicaciones de alta calidad y centradas en el usuario que aborden los desafíos únicos que enfrentan las comunidades en el mundo en desarrollo.",
        missionP2:
          "Nos comprometemos a empoderar a personas y organizaciones a través de la tecnología, promoviendo la inclusión digital e impulsando el impacto social. Al centrarnos en la colaboración, la innovación y la integridad, buscamos crear soluciones que no solo satisfagan las necesidades inmediatas, sino que también faciliten el desarrollo y la prosperidad a largo plazo.",
      },
      contact: {
        title: "Contáctenos",
        text: "¡Puede enviarnos un correo electrónico a contact@rook-tech.com y estaremos encantados de responderle lo antes posible!",
      },
    },
  },

  fr: {
    translation: {
      navbar: {
        home: "Accueil",
        about: "À Propos",
        services: "Services",
        vision: "Notre Vision",
        contact: "Contact",
      },
      home: {
        welcome: "Bienvenue chez",
        subtitle: "Nous créons de nouvelles technologies !",
      },
      about: {
        title: "À Propos de Nous",
        welcome: "Bienvenue chez Rook Tech !",
        highlight: "L'innovation au service du but.",
        p1: "Nous sommes une société de développement d'applications dédiée à la création de produits percutants et accessibles, adaptés aux besoins uniques du monde en développement.",
        p2: "Notre mission est de tirer parti des technologies de pointe pour résoudre des problèmes concrets, renforcer la connectivité et améliorer la qualité de vie des communautés à travers le monde.",
        p3: "Rejoignez-nous dans notre voyage pour faire une différence significative grâce à des solutions numériques réfléchies et inclusives.",
      },
      services: {
        title: "Nos Réalisations",
        subtitle:
          "Découvrez certains de nos derniers projets et solutions numériques.",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg vous aide à maîtriser les mots les plus utiles dans n'importe quelle langue grâce à des mini-jeux amusants basés sur des listes de fréquence.",
        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "La version mobile de LangoDawg, tout comme la version web, vous aide à maîtriser les mots les plus utiles dans n'importe quelle langue grâce à des mini-jeux amusants basés sur des listes de fréquence.",
        viewProject: "Voir le Projet",
        visitWebsite: "Visiter le Site",
        downloadAndroid: "App Android",
        downloadIOS: "App iOS",
        webPlatformTag: "Plateforme Web",
        mobileAppTag: "App Mobile",
      },
      mission: {
        visionTitle: "Notre Vision",
        visionP1:
          "Chez Rook Tech, notre vision est de devenir un leader mondial du développement d'applications en exploitant la puissance de la technologie pour créer des solutions innovantes et durables pour le monde en développement.",
        visionP2:
          "Nous envisageons un avenir où chaque communauté, quelles que soient les barrières géographiques et économiques, a accès à des outils numériques qui améliorent la qualité de vie, favorisent la croissance et stimulent un changement positif.",
        missionTitle: "Notre Mission",
        missionP1:
          "Notre mission chez Rook Tech est de concevoir et de développer des applications de haute qualité, centrées sur l'utilisateur, qui répondent aux défis uniques auxquels sont confrontées les communautés du monde en développement.",
        missionP2:
          "Nous nous engageons à donner aux individus et aux organisations les moyens d'agir grâce à la technologie, à promouvoir l'inclusion numérique et à générer un impact social positif. En misant sur la collaboration, l'innovation et l'intégrité, nous visons à concevoir des solutions qui non seulement répondent aux besoins immédiats, mais qui ouvrent également la voie à un développement et une prospérité durables.",
      },
      contact: {
        title: "Contactez-nous",
        text: "Vous pouvez nous envoyer un e-mail à contact@rook-tech.com et nous serons ravis de vous répondre dès que possible !",
      },
    },
  },

  zh: {
    translation: {
      navbar: {
        home: "首页",
        about: "关于我们",
        services: "服务内容",
        vision: "企业愿景",
        contact: "联系我们",
      },
      home: {
        welcome: "欢迎来到",
        subtitle: "我们创造新技术！",
      },
      about: {
        title: "关于我们",
        welcome: "欢迎来到 Rook Tech！",
        highlight: "创新与目标的结合。",
        p1: "我们是一家专注于应用程序开发的公司，致力于为发展中国家的独特需求量身定制具有影响力且易于使用的产品。",
        p2: "我们的使命是利用尖端技术解决现实世界的问题，加强连接性，并改善全球社区的生活质量。",
        p3: "加入我们的旅程，通过周到且包容的数字化解决方案，创造深远的影响。",
      },
      services: {
        title: "我们的作品",
        subtitle: "查看我们要些最新的项目和数字解决方案。",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg 通过基于频率列表的有趣迷你游戏，帮助您掌握任何语言中最有用的单词。",
        langoDawgMobileTitle: "LangoDawg 移动版",
        langoDawgMobileDesc:
          "LangoDawg 移动版与网页版一样，通过基于频率列表的有趣迷你游戏，帮助您掌握任何语言中最有用的单词。",
        viewProject: "查看项目",
        visitWebsite: "访问网站",
        downloadAndroid: "安卓应用",
        downloadIOS: "iOS 应用",
        webPlatformTag: "Web 平台",
        mobileAppTag: "移动应用",
      },
      mission: {
        visionTitle: "企业愿景",
        visionP1:
          "在 Rook Tech，我们的愿景是通过利用技术的力量，为发展中国家创造创新且可持续的解决方案，成为应用程序开发领域的全球领导者。",
        visionP2:
          "我们憧憬这样一个未来：无论地理和经济障碍如何，每个社区都能获得数字化工具，从而提高生活质量，促进增长并推动积极变革。",
        missionTitle: "核心使命",
        missionP1:
          "Rook Tech 的使命是设计和开发高质量、以用户为中心的应用程序，以解决发展中国家社区所面临的独特挑战。",
        missionP2:
          "我们致力于通过技术赋能个人和组织，促进数字包容，并推动社会发展。我们秉持协作、创新和诚信的原则，力求打造不仅满足当前需求，更着眼于长远发展和繁荣的解决方案。",
      },
      contact: {
        title: "联系我们",
        text: "请通过 contact@rook-tech.com 与我们联系，我们将尽快回复！",
      },
    },
  },

  hi: {
    translation: {
      navbar: {
        home: "होम",
        about: "हमारे बारे में",
        services: "सेवाएं",
        vision: "हमारा दृष्टिकोण",
        contact: "संपर्क",
      },
      home: {
        welcome: "स्वागत है",
        subtitle: "हम नई तकनीकें बनाते हैं!",
      },
      about: {
        title: "हमारे बारे में",
        welcome: "Rook Tech में आपका स्वागत है!",
        highlight: "जहाँ नवाचार उद्देश्य से मिलता है।",
        p1: "हम एक एप्लिकेशन डेवलपमेंट कंपनी हैं जो विकासशील दुनिया की अनूठी जरूरतों के लिए प्रभावशाली और सुलभ उत्पाद बनाने के लिए समर्पित हैं।",
        p2: "हमारा मिशन वास्तविक दुनिया की समस्याओं को हल करने, कनेक्टिविटी बढ़ाने और दुनिया भर के समुदायों के जीवन की गुणवत्ता में सुधार करने के लिए अत्याधुनिक तकनीक का लाभ उठाना है।",
        p3: "विचारशील और समावेशी डिजिटल समाधानों के माध्यम से सार्थक बदलाव लाने की हमारी यात्रा में शामिल हों।",
      },
      services: {
        title: "हमारा काम",
        subtitle: "हमारे कुछ नवीनतम प्रोजेक्ट्स और डिजिटल समाधान देखें।",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg आपको फ्रीक्वेंसी लिस्ट पर आधारित मजेदार मिनी-गेम्स के माध्यम से किसी भी भाषा के सबसे उपयोगी शब्दों में महारत हासिल करने में मदद करता है।",
        langoDawgMobileTitle: "LangoDawg मोबाइल",
        langoDawgMobileDesc:
          "LangoDawg मोबाइल संस्करण, वेब संस्करण की तरह ही, आपको फ्रीक्वेंसी लिस्ट पर आधारित मजेदार मिनी-गेम्स के माध्यम से किसी भी भाषा के सबसे उपयोगी शब्दों में महारत हासिल करने में मदद करता है।",
        viewProject: "प्रोजेक्ट देखें",
        visitWebsite: "वेबसाइट पर जाएं",
        downloadAndroid: "एंड्रॉइड ऐप",
        downloadIOS: "iOS ऐप",
        webPlatformTag: "वेब प्लेटफॉर्म",
        mobileAppTag: "मोबाइल ऐप",
      },
      mission: {
        visionTitle: "हमारा दृष्टिकोण",
        visionP1:
          "Rook Tech में, हमारा दृष्टिकोण विकासशील दुनिया के लिए अभिनव और टिकाऊ समाधान बनाने के लिए प्रौद्योगिकी की शक्ति का उपयोग करके एप्लिकेशन डेवलपमेंट में एक वैश्विक नेता बनना है।",
        visionP2:
          "हम एक ऐसे भविष्य की कल्पना करते हैं जहां भौगोलिक और आर्थिक बाधाओं के बावजूद हर समुदाय के पास डिजिटल टूल तक पहुंच हो जो जीवन की गुणवत्ता को बढ़ाते हैं और सकारात्मक बदलाव लाते हैं।",
        missionTitle: "हमारा मिशन",
        missionP1:
          "Rook Tech में हमारा मिशन उच्च गुणवत्ता वाले, उपयोगकर्ता-केंद्रित एप्लिकेशन डिजाइन और विकसित करना है जो विकासशील दुनिया में समुदायों द्वारा सामना की जाने वाली अनूठी चुनौतियों का समाधान करते हैं।",
        missionP2:
          "हम प्रौद्योगिकी के माध्यम से व्यक्तियों और संगठनों को सशक्त बनाने, डिजिटल समावेशन को बढ़ावा देने और सामाजिक प्रभाव को आगे बढ़ाने के लिए प्रतिबद्ध हैं। सहयोग, नवाचार और ईमानदारी पर ध्यान केंद्रित करते हुए, हमारा लक्ष्य ऐसे समाधान विकसित करना है जो न केवल तात्कालिक आवश्यकताओं को पूरा करें बल्कि दीर्घकालिक विकास और समृद्धि का मार्ग भी प्रशस्त करें।",
      },
      contact: {
        title: "संपर्क करें",
        text: "हमें contact@rook-tech.com पर ईमेल करें और हमें यथाशीघ्र उत्तर देने में खुशी होगी!",
      },
    },
  },

  ar: {
    translation: {
      navbar: {
        home: "الرئيسية",
        about: "حولنا",
        services: "خدماتنا",
        vision: "رؤيتنا",
        contact: "اتصل بنا",
      },
      home: {
        welcome: "مرحباً بكم في",
        subtitle: "نحن نصنع تقنيات جديدة!",
      },
      about: {
        title: "حول الشركة",
        welcome: "مرحباً بكم في Rook Tech!",
        highlight: "حيث يلتقي الابتكار بالهدف.",
        p1: "نحن شركة تطوير تطبيقات مكرسة لإنشاء منتجات مؤثرة وسهلة الاستخدام، مصممة خصيصاً لتلبية الاحتياجات الفريدة للعالم النامي.",
        p2: "مهمتنا هي الاستفادة من أحدث التقنيات لحل مشاكل العالم الحقيقي، وتعزيز التواصل، وتحسين جودة الحياة للمجتمعات في جميع أنحاء العالم.",
        p3: "انضم إلينا في رحلتنا لإحداث فرق ملموس من خلال حلول رقمية مدروسة وشاملة للجميع.",
      },
      services: {
        title: "أعمالنا",
        subtitle: "اطلع على أحدث مشاريعنا والحلول الرقمية.",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "يساعدك LangoDawg على إتقان الكلمات الأكثر فائدة في أي لغة من خلال ألعاب مصغرة ممتعة تعتمد على قوائم التكرار.",
        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "تساعدك نسخة الهاتف من LangoDawg، تمامًا مثل نسخة الويب، على إتقان الكلمات الأكثر فائدة في أي لغة من خلال ألعاب مصغرة ممتعة تعتمد على قوائم التكرار.",
        viewProject: "عرض المشروع",
        visitWebsite: "زيارة الموقع",
        downloadAndroid: "تطبيق أندرويد",
        downloadIOS: "تطبيق iOS",
        webPlatformTag: "منصة ويب",
        mobileAppTag: "تطبيق جوال",
      },
      mission: {
        visionTitle: "رؤيتنا",
        visionP1:
          "في Rook Tech، تتمثل رؤيتنا في أن نصبح رائداً عالمياً في تطوير التطبيقات من خلال تسخير قوة التكنولوجيا لإنشاء حلول مبتكرة ومستدامة للعالم النامي.",
        visionP2:
          "نحن نتصور مستقبلاً يتمكن فيه كل مجتمع، بغض النظر عن العوائق الجغرافية والاقتصادية، من الوصول إلى الأدوات الرقمية التي تعزز جودة الحياة وتدفع التغيير الإيجابي.",
        missionTitle: "مهمتنا",
        missionP1:
          "مهمتنا في Rook Tech هي تصميم وتطوير تطبيقات عالية الجودة تتمحور حول المستخدم، وتعالج التحديات الفريدة التي تواجه المجتمعات في العالم النامي.",
        missionP2:
          "نحن ملتزمون بتمكين الأفراد والمؤسسات من خلال التكنولوجيا، وتعزيز الشمول الرقمي، وإحداث أثر اجتماعي إيجابي. ومن خلال التركيز على التعاون والابتكار والنزاهة، نسعى إلى بناء حلول لا تقتصر على تلبية الاحتياجات الآنية فحسب، بل تمهد الطريق أيضاً للتنمية والازدهار على المدى الطويل.",
      },
      contact: {
        title: "اتصل بنا",
        text: "يمكنكم مراسلتنا عبر البريد الإلكتروني contact@rook-tech.com وسنكون سعداء بالرد في أقرب وقت ممكن!",
      },
    },
  },

  ru: {
    translation: {
      navbar: {
        home: "Главная",
        about: "О нас",
        services: "Услуги",
        vision: "Наше видение",
        contact: "Контакт",
      },
      home: {
        welcome: "Добро пожаловать в",
        subtitle: "Мы создаем новые технологии!",
      },
      about: {
        title: "О нас",
        welcome: "Добро пожаловать в Rook Tech!",
        highlight: "Где инновации обретают смысл.",
        p1: "Мы — компания по разработке приложений, стремящаяся создавать значимые и доступные продукты, адаптированные к уникальным потребностям развивающегося мира.",
        p2: "Наша миссия заключается в использовании передовых технологий для решения реальных проблем, расширения возможностей связи и улучшения качества жизни сообществ по всему миру.",
        p3: "Присоединяйтесь к нам в нашем стремлении изменить мир к лучшему с помощью продуманных и инклюзивных цифровых решений.",
      },
      services: {
        title: "Наши работы",
        subtitle:
          "Ознакомьтесь с нашими последними проектами и цифровыми решениями.",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg помогает освоить самые полезные слова любого языка с помощью увлекательных мини-игр, основанных на частотных списках.",
        langoDawgMobileTitle: "LangoDawg Mobile",
        langoDawgMobileDesc:
          "Мобильная версия LangoDawg, как и веб-версия, помогает освоить самые полезные слова любого языка с помощью увлекательных мини-игр, основанных на частотных списках.",
        viewProject: "Смотреть проект",
        visitWebsite: "Посетить сайт",
        downloadAndroid: "Android приложение",
        downloadIOS: "iOS приложение",
        webPlatformTag: "Веб-платформа",
        mobileAppTag: "Мобильное приложение",
      },
      mission: {
        visionTitle: "Наше видение",
        visionP1:
          "Видение Rook Tech — стать мировым лидером в области разработки приложений, используя возможности технологий для создания инновационных и устойчивых решений для развивающихся стран.",
        visionP2:
          "Мы видим будущее, в котором каждое сообщество, независимо от географических и экономических барьеров, имеет доступ к цифровым инструментам, которые повышают качество жизни и способствуют росту.",
        missionTitle: "Наша миссия",
        missionP1:
          "Миссия Rook Tech заключается в проектировании и разработке высококачественных, ориентированных на пользователя приложений, которые решают уникальные задачи развивающихся сообществ.",
        missionP2:
          "Мы стремимся расширять возможности отдельных лиц и организаций с помощью технологий, содействовать цифровой интеграции и оказывать социальное воздействие. Сосредоточившись на сотрудничестве, инновациях и честности, мы стремимся создавать решения, которые не только удовлетворяют сиюминутные потребности, но и прокладывают путь к долгосрочному развитию и процветанию.",
      },
      contact: {
        title: "Свяжитесь с нами",
        text: "Пишите нам на contact@rook-tech.com, и мы будем рады ответить вам в кратчайшие сроки!",
      },
    },
  },

  bn: {
    translation: {
      navbar: {
        home: "হোম",
        about: "আমাদের সম্পর্কে",
        services: "সেবাসমূহ",
        vision: "আমাদের লক্ষ্য",
        contact: "যোগাযোগ",
      },
      home: {
        welcome: "স্বাগতম",
        subtitle: "আমরা নতুন প্রযুক্তি তৈরি করি!",
      },
      about: {
        title: "আমাদের সম্পর্কে",
        welcome: "রুক টেক-এ (Rook Tech) স্বাগতম!",
        highlight: "যেখানে উদ্ভাবন উদ্দেশ্যের সাথে মিলিত হয়।",
        p1: "আমরা একটি অ্যাপ্লিকেশন ডেভেলপমেন্ট কোম্পানি যা উন্নয়নশীল বিশ্বের অনন্য প্রয়োজনের জন্য প্রভাবশালী এবং সহজলভ্য পণ্য তৈরির জন্য নিবেদিত।",
        p2: "আমাদের লক্ষ্য হলো বাস্তব বিশ্বের সমস্যার সমাধান, সংযোগ বৃদ্ধি এবং বিশ্বজুড়ে সম্প্রদায়ের জীবনযাত্রার মান উন্নত করতে অত্যাধুনিক প্রযুক্তি ব্যবহার করা।",
        p3: "চিন্তাশীল এবং অন্তর্ভুক্তিমূলক ডিজিটাল সমাধানের মাধ্যমে একটি অর্থবহ পরিবর্তন আনার যাত্রায় আমাদের সাথে যোগ দিন।",
      },
      services: {
        title: "আমাদের কাজ",
        subtitle: "আমাদের কিছু সাম্প্রতিক প্রজেক্ট এবং ডিজিটাল সমাধান দেখুন।",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg আপনাকে ফ্রিকোয়েন্সি তালিকার উপর ভিত্তি করে মজার মিনি গেমের মাধ্যমে যেকোনো ভাষার সবচেয়ে প্রয়োজনীয় শব্দগুলো আয়ত্ত করতে সাহায্য করে।",
        langoDawgMobileTitle: "LangoDawg মোবাইল",
        langoDawgMobileDesc:
          "LangoDawg মোবাইল সংস্করণ, ওয়েব সংস্করণের মতোই, আপনাকে ফ্রিকোয়েন্সি তালিকার উপর ভিত্তি করে মজার মিনি গেমের মাধ্যমে যেকোনো ভাষার সবচেয়ে প্রয়োজনীয় শব্দগুলো আয়ত্ত করতে সাহায্য করে।",
        viewProject: "প্রজেক্ট দেখুন",
        visitWebsite: "ওয়েবসাইট দেখুন",
        downloadAndroid: "অ্যান্ড্রয়েড অ্যাপ",
        downloadIOS: "iOS অ্যাপ",
        webPlatformTag: "ওয়েব প্ল্যাটফর্ম",
        mobileAppTag: "মোবাইল অ্যাপ",
      },
      mission: {
        visionTitle: "আমাদের লক্ষ্য",
        visionP1:
          "রুক টেক-এ আমাদের লক্ষ্য হলো উন্নয়নশীল বিশ্বের জন্য উদ্ভাবনী এবং টেকসই সমাধান তৈরির মাধ্যমে অ্যাপ্লিকেশন ডেভেলপমেন্টে বিশ্বব্যাপী নেতৃত্ব প্রদান করা।",
        visionP2:
          "আমরা এমন একটি ভবিষ্যতের কল্পনা করি যেখানে ভৌগোলিক এবং অর্থনৈতিক বাধা নির্বিশেষে প্রতিটি সম্প্রদায়ের ডিজিটাল সরঞ্জাম ব্যবহারের সুযোগ থাকবে, যা জীবনযাত্রার মান উন্নত করবে এবং ইতিবাচক পরিবর্তন আনবে।",
        missionTitle: "আমাদের উদ্দেশ্য",
        missionP1:
          "রুক টেক-এর উদ্দেশ্য হলো উচ্চ-মানের, ব্যবহারকারী-কেন্দ্রিক অ্যাপ্লিকেশন ডিজাইন এবং ডেভেলপ করা যা উন্নয়নশীল বিশ্বের সম্প্রদায়ের অনন্য চ্যালেঞ্জগুলো মোকাবিলা করে।",
        missionP2:
          "আমরা প্রযুক্তির মাধ্যমে ব্যক্তি ও প্রতিষ্ঠানের ক্ষমতায়ন, ডিজিটাল অন্তর্ভুক্তি প্রচার এবং সামাজিক প্রভাব বৃদ্ধিতে প্রতিশ্রুতিবদ্ধ। সহযোগিতা, উদ্ভাবন এবং সততার উপর দৃষ্টি নিবদ্ধ করে, আমরা এমন সমাধান তৈরির লক্ষ্য রাখি যা কেবল তাৎক্ষণিক চাহিদা পূরণ করে না বরং দীর্ঘমেয়াদী উন্নয়ন ও সমৃদ্ধির পথও প্রশস্ত করে।",
      },
      contact: {
        title: "যোগাযোগ করুন",
        text: "contact@rook-tech.com এ আমাদের ইমেল করুন, আমরা দ্রুত উত্তর দিতে খুশি হব!",
      },
    },
  },

  ur: {
    translation: {
      navbar: {
        home: "ہوم",
        about: "ہمارے بارے میں",
        services: "خدمات",
        vision: "ہمارا وژن",
        contact: "رابطہ",
      },
      home: {
        welcome: "خوش آمدید",
        subtitle: "ہم نئی ٹیکنالوجیز بناتے ہیں!",
      },
      about: {
        title: "ہمارے بارے میں",
        welcome: "Rook Tech میں خوش آمدید!",
        highlight: "جہاں جدت مقصد سے ملتی ہے۔",
        p1: "ہم ایک ایپلی کیشن ڈویلپمنٹ کمپنی ہیں جو ترقی پذیر دنیا کی منفرد ضروریات کے مطابق بااثر اور قابل رسائی مصنوعات بنانے کے لیے وقف ہیں۔",
        p2: "ہمارا مشن جدید ترین ٹیکنالوجی کا فائدہ اٹھا کر حقیقی دنیا کے مسائل حل کرنا، رابطوں کو بڑھانا اور دنیا بھر کی کمیونٹیز کے معیار زندگی کو بہتر بنانا ہے۔",
        p3: "سوچ سمجھ کر بنائے گئے اور جامع ڈیجیٹل حل کے ذریعے ایک بامعنی تبدیلی لانے کے ہمارے سفر میں شامل ہوں۔",
      },
      services: {
        title: "ہمارا کام",
        subtitle: "ہمارے کچھ حالیہ پروجیکٹس اور ڈیجیٹل حل دیکھیں۔",
        langoDawgWebTitle: "LangoDawg",
        langoDawgWebDesc:
          "LangoDawg فریکوئنسی لسٹوں پر مبنی تفریحی منی گیمز کے ذریعے کسی بھی زبان کے سب سے مفید الفاظ میں مہارت حاصل کرنے میں آپ کی مدد کرتا ہے۔",
        langoDawgMobileTitle: "LangoDawg موبائل",
        langoDawgMobileDesc:
          "LangoDawg موبائل ورژن، بالکل ویب ورژن کی طرح، فریکوئنسی لسٹوں پر مبنی تفریحی منی گیمز کے ذریعے کسی بھی زبان کے سب سے مفید الفاظ میں مہارت حاصل کرنے میں آپ کی مدد کرتا ہے۔",
        viewProject: "پروجیکٹ دیکھیں",
        visitWebsite: "ویب سائٹ دیکھیں",
        downloadAndroid: "اینڈروئیڈ ایپ",
        downloadIOS: "iOS ایپ",
        webPlatformTag: "ویب پلیٹ فارم",
        mobileAppTag: "موبائل ایپ",
      },
      mission: {
        visionTitle: "ہمارا وژن",
        visionP1:
          "Rook Tech میں، ہمارا وژن ترقی پذیر دنیا کے لیے اختراعی اور پائیدار حل پیدا کرنے کے لیے ٹیکنالوجی کی طاقت کو بروئے کار لاتے ہوئے ایپلی کیشن ڈویلپمنٹ میں عالمی رہنما بننا ہے۔",
        visionP2:
          "ہم ایک ایسے مستقبل کا تصور کرتے ہیں جہاں ہر کمیونٹی، جغرافیائی اور معاشی رکاوٹوں کے باوجود، ان ڈیجیٹل آلات تک رسائی حاصل کرے جو معیار زندگی کو بلند کرتے ہیں اور مثبت تبدیلی لاتے ہیں۔",
        missionTitle: "ہمارا مشن",
        missionP1:
          "Rook Tech میں ہمارا مشن اعلیٰ معیار کی، صارف دوست ایپلی کیشنز ڈیزائن اور تیار کرنا ہے جو ترقی پذیر دنیا میں کمیونٹیز کو درپیش منفرد چیلنجوں کو حل کرتی ہیں۔",
        missionP2:
          "ہم ٹیکنالوجی کے ذریعے افراد اور تنظیموں کو بااختیار بنانے، ڈیجیٹل شمولیت کو فروغ دینے اور سماجی اثرات کو آگے بڑھانے کے لیے پرعزم ہیں۔ تعاون، اختراع، اور سالمیت پر توجہ مرکوز کرتے ہوئے، ہم ایسے حل تیار کرنا چاہتے ہیں جو نہ صرف فوری ضروریات کو پورا کرتے ہوں بلکہ طویل مدتی ترقی اور خوشحالی کی راہ بھی ہموار کرتے ہوں۔",
      },
      contact: {
        title: "رابطہ کریں",
        text: "ہمیں contact@rook-tech.com پر ای میل کریں اور ہمیں جلد از جلد جواب دے کر خوشی ہوگی!",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "pt", "es", "zh", "hi", "fr", "ar", "bn", "ru", "ur"],
    detection: {
      order: ["sessionStorage", "navigator"],
      lookupSessionStorage: "i18nextLng",
      caches: ["sessionStorage"],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
